/**
 * 用户中心相关API接口
 */
import request from './utils/request'

/**
 * 查询数字备案详细
 * @param {string} id - 数字备案ID
 * @returns {Promise} 查询数字备案详细结果
 */
export function queryOriginalWorkFilingId(id) {
    return request({
      url: '/web/filing/originalWorkFiling/queryOriginalWorkFilingId',
      method: 'post',
      data: id
    })
  }

/**
 * 新增原创作品数字备案
 * @param {Object} data - 原创作品数字备案数据
 * @param {string} data.workName - 作品名称
 * @param {string} data.applicant - 申请人
 * @param {string} data.worksType - 作品类型
 * @param {string} data.worksInstructions - 作品说明
 * @param {string} data.complianceInstructions - 合规性说明
 * @param {string} data.proofType - 备案类型
 * @param {string} data.citationStatus - 是否引用其他产品设计
 * @param {array} data.attachment - 附件资料（多个文件URL数组，格式：[{ url: string, name?: string }]）
 * @param {string} data.modelName - 模型名称
 * @param {boolean} data.isCooperativeWork - 是否合作作品
 * @param {string} data.firstPublishedLink - 首次发表链接
 * @param {string} data.signatureUrl - 扫码签名地址
 * @param {string} data.basicOrInternationalType - 选择基础版或者国际版 '0' 基础版 | '1' 国际版
 * @returns {Promise} 新增原创作品数字备案结果
 */
export function addOriginalWorkFiling(data) {
    return request({
      url: '/web/filing/originalWorkFiling/addOriginalWorkFiling',
      method: 'post',
      data: data
    })
  }

/**
 * 修改原创作品数字备案
 * @param {Object} data - 原创作品数字备案数据
 * @param {string} data.id - 数字备案ID
 * @param {string} data.nameTitle - 作品名称
 * @param {string} data.applicant - 申请人
 * @param {string} data.worksType - 作品类型
 * @param {string} data.worksInstructions - 作品说明
 * @param {string} data.complianceInstructions - 合规性说明
 * @param {string} data.proofType - 备案类型
 * @param {string} data.citationStatus - 是否引用其他产品设计
 * @param {array} data.attachment - 附件资料（多个文件URL数组，格式：[{ url: string, name?: string }]）
 * @param {boolean} data.isCooperativeWork - 是否合作作品
 * @param {string} data.firstPublishedLink - 首次发表链接
 * @param {string} data.signatureUrl - 扫码签名地址
 * @param {string} data.basicOrInternationalType - 选择基础版或者国际版 '0' 基础版 | '1' 国际版
 * @returns {Promise} 新增原创作品数字备案结果
 */
export function updateFiling(data, config = {}) {
    return request({
      url: '/web/filing/originalWorkFiling/updateOriginalWorkFiling',
      method: 'post',
      data: data,
      ...config
    })
  }

  
/**
 * 修改原创作品数字备案
 * @param {Object} data - 原创作品数字备案数据
 * @param {string} data.id - 数字备案ID
 * @param {string} data.signatureUrl - 扫码签名地址
 * @returns {Promise} 新增原创作品数字备案结果
 */
export function upSignature(data) {
  return request({
    url: '/web/filing/originalWorkFiling/upSignature',
    method: 'post',
    data: data
  })
}
  
  // 删除数字备案
  export function delFiling(ids) {
    return request({
      url: '/system/filing/removeByIds',
      method: 'post',
      data: ids
    })
  }

  //我的备案重新详情
export function getFiling(id) {
  return request({
    url: '/web/filing/myRecordFiling/getById',
    method: 'get',
    params: { id: id }
  })
}

// 查询数字备案列表
export function listFiling(query) {
  return request({
    url: '/web/filing/myRecordFiling/filingList',
    method: 'get',
    params: query
  })
}


//审核备案生成证书发送邮件 (基础版-原创作品版权备案)
export function asynchronousAuditAndCertificateSendingWork(data) {
  return request({
    url: '/web/certificateAuthentication/asynchronousAuditAndCertificateSending',
    method: 'post',
    data: data
  })
}

//审核备案生成证书发送邮件 (基础版-原创产品设计备案)
export function asynchronousAuditAndCertificateSendingProductDesign(data) {
  return request({
    url: '/web/certificateAuthentication/asynchronousAuditAndCertificateSendingProductDesign',
    method: 'post',
    data: data
  })
}

//审核备案生成证书发送邮件 (国际版)
export function asynchronousAuditAndCertificateSendingIntl(data) {
  return request({
    url: '/web/certificateAuthentication/asynchronousAuditAndCertificateSendingIntl',
    method: 'post',
    data: data
  })
}

//审核备案生成证书发送邮件
export function sendFilingEmail(data, skipGlobalErrorHandler = false) {
  return request({
    url: '/web/filing/sendFilingEmail',
    method: 'post',
    data: data,
    skipGlobalErrorHandler
  })
}


//备案类型简介
export function getFilingType(filingType) {
  return request({
    url: '/web/filing/getFilingType',
    method: 'get',
    params: { filingType: filingType }
  })
}

//原创作品分类列表
export function getDictList(dictType) {
  return request({
    url: '/web/filing/dictData',
    method: 'get',
    params: { dictType: dictType }
  })
}

// 查询备案已转让库列表
export function transferCredentialsList(query) {
  return request({
    url: '/web/filing/myRecordFiling/transferCredentialsList',
    method: 'get',
    params: query
  })
}

// 查询备案已授权库列表
export function authCredentialsList(query) {
  return request({
    url: '/web/filing/myRecordFiling/authCredentialsList',
    method: 'get',
    params: query
  })
}

// 查询备案草稿箱
export function draftList(query) {
  return request({
    url: '/web/filing/myRecordFiling/draftList',
    method: 'get',
    params: query
  })
}

// 查询数字备案证书（type: 0-国内，1-国外/国际版）
export function queryFilingNumberInfo(keyword, type = '0') {
  return request({
    url: '/web/filing/myRecordFiling/queryFilingNumberInfo',
    method: 'get',
    params: { keyword, type }
  })
}

// 查询迁移旧数字备案记录
export function getMigrationFilingRecordByFilingNumber(filingNumber) {
  return request({
    url: '/web/migrationFilingRecords/getByFilingNumber',
    method: 'get',
    params: { filingNumber }
  })
}

// 根据原备案id查询迁移旧数字备案记录
export function getMigrationFilingRecordByFilingId(filingId) {
  return request({
    url: '/web/migrationFilingRecords/getById',
    method: 'get',
    params: { filingId }
  })
}

//查询时间戳
export function selectTime(params) {
  return request({
    url: '/web/filing/originalWorkFiling/selectTime',
    method: 'get',
    params: params
  })
}
